const getRowsFromRawData = (_rows, headers) =>
  _rows[0].map((_, j) => ({
    key: `item-${j}`,
    fields: headers
      .map((_header, index) => {
        const { column } = _header;
        return {
          [column]: _rows[index]?.[j] || ''
        };
      })
      .reduce((result, currentObj) => ({ ...result, ...currentObj }), {})
  }));

const getRowsFromRankedData = (input) => {
  const { columns, data, index } = input;
  let formattedColumns;
  let formattedData;

  if (Array.isArray(columns)) {
    formattedColumns = columns;
  } else if (typeof columns === 'object') {
    formattedColumns = Object.values(columns);
  } else {
    return null;
  }

  if (Array.isArray(data)) {
    formattedData = data;
  } else if (typeof data === 'object') {
    formattedData = Object.values(data);
  } else {
    return null;
  }

  if (
    !formattedColumns ||
    formattedColumns.length === 0 ||
    !formattedData ||
    formattedData.length === 0
  ) {
    return null;
  }

  return formattedData.map((row, rowIndex) => {
    const fields = {};
    formattedColumns.forEach((column, colIndex) => {
      fields[column] = row[colIndex];
    });
    return {
      key: `item-${index[rowIndex]}`,
      fields
    };
  });
};

export { getRowsFromRawData, getRowsFromRankedData };
